// extracted by extract-css-chunks-webpack-plugin
module.exports = {"confirmationDetails":"qIGWo","summaryWrapper":"_98js4"};